// Copyright ©️ 2026 eVolve MEP, LLC

import { type MachineElement, useEvolvePatch } from '@evolvemep/api-ts';

import { CustomPropertiesList } from 'components/Mantine/CustomProperties/CustomPropertiesList';

import { ManageBendCustomProperties } from '../../ManageBendCustomProperties';
import { BendDataCard } from './BendDataCard';

type Props = {
  element: MachineElement;
  onPropertiesUpdated: (element: MachineElement) => void;
};

/** Allows the user to view and update custom properties on a given bend element. */
export const BendCustomProperties = ({ element, onPropertiesUpdated }: Props) => {
  const { apiCall: patchPropertiesApiCall, loading: saving } = useEvolvePatch(
    `shop/fabrication/element/${element.elementId}`,
  );

  return (
    <BendDataCard title="Custom Properties" rightSection={<ManageBendCustomProperties disabled={saving} />}>
      <CustomPropertiesList
        entity={element}
        customPropertyTypeName="Fabrication Item"
        onUpdateCustomProperty={async (customPropertyId, value) => {
          await patchPropertiesApiCall({ customProperties: [{ customPropertyId, value }] }).then(onPropertiesUpdated);
        }}
        disabled={saving}
      />
    </BendDataCard>
  );
};
